export function toDollarString(amount: string): string {
  const a = parseFloat(amount);
  return `$${a.toLocaleString()}`;
} 
